import { render } from "./Project2View.vue?vue&type=template&id=1110d0e9&scoped=true"
import script from "./Project2View.vue?vue&type=script&lang=js"
export * from "./Project2View.vue?vue&type=script&lang=js"

import "./Project2View.vue?vue&type=style&index=0&id=1110d0e9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1110d0e9"]])

export default __exports__